const DOCUMENTS_ACTIONS = {
  DOCUMENTS_LOADED: 'DOCUMENTS_LOADED',
  DOCUMENT_LOADED: 'DOCUMENT_LOADED',
  DOCUMENT_CLEARED: 'DOCUMENT_CLEARED',
  DOCUMENTS_FILTERED: 'DOCUMENTS_FILTERED'
};

const documentsLoadedAction = ({ documents, type, source, route }) => {
  return {
    type: DOCUMENTS_ACTIONS.DOCUMENTS_LOADED,
    payload: { type, documents, source, route }
  };
};
const clearCurrentDocumentAction = () => {
  return {
    type: DOCUMENTS_ACTIONS.DOCUMENT_CLEARED,
    payload: {}
  };
};
const documentLoadedAction = ({ document, type }) => {
  return {
    type: DOCUMENTS_ACTIONS.DOCUMENT_LOADED,
    payload: { type, document }
  };
};

const documentsFilteredAction = ({ documents, type }) => {
  return {
    type: DOCUMENTS_ACTIONS.DOCUMENTS_FILTERED,
    payload: { type, documents }
  };
};

export {
  DOCUMENTS_ACTIONS,
  documentsLoadedAction,
  documentLoadedAction,
  documentsFilteredAction,
  clearCurrentDocumentAction
};
